import React, { useRef, useCallback, useEffect, useState } from "react";
import {
   ReactFlow,
   addEdge,
   useNodesState,
   useEdgesState,
   Background,
   ReactFlowProvider,
   useReactFlow,
   Panel,
   Position,
   Handle,
   useUpdateNodeInternals,
} from "@xyflow/react";

import "@xyflow/react/dist/style.css";
import { allEdges, anrufleitfadenObject } from "./anrufleitfaden";

let allNewEdges = [];

Object.values(anrufleitfadenObject).forEach((frage, fragenIndex) => {
   frage.data.antworten.forEach((antwort, antwortIndex) => {
      allNewEdges.push({
         id: frage.id + antwort.weiter + antwortIndex,
         source: frage.id,
         sourceHandle: "handle_" + frage.id + "_" + antwortIndex,
         target: antwort.weiter,
         selectable: false,
         className: "leitfaden-edge",
         markerEnd: { type: "arrowclosed", color: "#333" },
         //  type: "simplebezier"
      });
   });
});

const ZoomTransition = () => {
   const [nodes, setNodes, onNodesChange] = useNodesState(/* initialNodes */ []);
   const [edges, setEdges, onEdgesChange] = useEdgesState(/* initialEdges */ allNewEdges);
   const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), []);
   const [currentNode, setCurrentNode] = useState("f0");
   const [prevNode, setPrevNode] = useState("f0");
   const [unterlagen, setUnterlagen] = useState();

   const { setViewport, zoomIn, zoomOut, fitView } = useReactFlow();

   const nodeTypes = {
      buttonNode: CustomButtonNode,
      textUpdater: TextUpdaterNode,
   };

   useEffect(() => {
      setNodes(() => {
         return Object.values(anrufleitfadenObject).map((item) => ({
            ...item,
            data: {
               ...item.data,
               currentNode: currentNode,
               setCurrentNode: setCurrentNode,
               prevNode: prevNode,
               setPrevNode: setPrevNode,
               unterlagen: unterlagen,
               setUnterlagen: setUnterlagen,
            },
         }));
      });

      console.log(allNewEdges);
   }, [currentNode]);

   const handleTransform = useCallback(
      (posi) => {
         setViewport({ x: -posi.x + 500, y: -posi.y + 50, zoom: 1 }, { duration: 800 });
      },
      [setViewport],
   );

   return (
      <ReactFlow
         nodes={nodes}
         edges={edges}
         nodeTypes={nodeTypes}
         onNodesChange={onNodesChange}
         onEdgesChange={onEdgesChange}
         onConnect={onConnect}
         panOnScroll={true}
         selectionOnDrag={false}
         panOnDrag={false}
         minZoom={0.001}
         defaultViewport={{ x: 100, y: 30, zoom: 1 }}
      >
         <Panel position="top-right">
            <div className="m-3" style={{ backgroundColor: "#fff" }}>
               {prevNode && (
                  <button
                     className="leitfaden-menubutton ms-0"
                     onClick={() => {
                        handleTransform(anrufleitfadenObject[prevNode].position);
                        setCurrentNode(prevNode);
                        setPrevNode(false);
                     }}
                  >
                     Zurück
                  </button>
               )}
               <button
                  className="leitfaden-menubutton "
                  onClick={() => {
                     setPrevNode(currentNode);
                     setCurrentNode("f0");
                     handleTransform(anrufleitfadenObject["f0"].position);
                  }}
               >
                  Zum Start
               </button>
               <button
                  className="leitfaden-menubutton"
                  onClick={() => {
                     handleTransform(anrufleitfadenObject[currentNode].position);
                  }}
               >
                  Zur Frage
               </button>
               <button
                  className="leitfaden-menubutton me-0"
                  style={{ backgroundColor: "#fff", color: "#000", boxShadow: "0 0 10px #999" }}
                  onClick={() => fitView({ duration: 1500 })}
               >
                  Zur Übersicht
               </button>
            </div>
         </Panel>
         <Background bgColor="#fefefe" color="#fff" />
      </ReactFlow>
   );
};

export default function MyFlowCharts({}) {
   return (
      <div style={{ width: "100vw", height: "100vh" }}>
         <ReactFlowProvider>
            <ZoomTransition />
         </ReactFlowProvider>
      </div>
   );
}

function CustomButtonNode(props) {
   const updateNodeInternals = useUpdateNodeInternals();
   const { setViewport, zoomIn, zoomOut, fitView } = useReactFlow();
   const textElementRef = useRef(null);
   const [ele, setEle] = useState();

   const handleTransform = useCallback(
      (posi) => {
         setViewport({ x: -posi.x + 500, y: -posi.y + 30, zoom: 1 }, { duration: 800 });
      },
      [setViewport],
   );

   useEffect(() => {
      console.log(props);
      setEle(textElementRef);
   }, []);

   useEffect(() => {
      updateNodeInternals(props.id);
   }, [ele]);

   return (
      <div
         onClick={() => {
            if (!(props.data.currentNode === props.id)) {
               props.data.setPrevNode(props.data.currentNode);
               props.data.setCurrentNode(props.id);

               handleTransform(anrufleitfadenObject[props.id].position);
            }
         }}
         className="text-updater-node"
         style={{
            boxShadow: "0 0 40px #999",
            backgroundColor: "#fffffe",
            width: "1200px",
            height: "1300px",
            border: "solid 1px #999",
            padding: "0px",
            borderRadius: "40px",
            opacity: props.data.currentNode === props.id ? 1 : 0.4,
         }}
      >
         <div>
            <Handle type="target" position={Position.Left} />
            <div ref={textElementRef} style={{ padding: "40px", paddingBottom: "0px" }}>
               {/* <h5>{props.id}</h5> */}
               <div
                  style={{ fontSize: "x-large", fontWeight: "600", marginBottom: "20px" }}
                  dangerouslySetInnerHTML={{ __html: props.data.frage }}
               />
               {props.id === "unterlagen" && props.data.unterlagen && (
                  <div
                     style={{ fontSize: "x-large", fontWeight: "600", marginBottom: "20px" }}
                     dangerouslySetInnerHTML={{
                        __html: props.data.unterlagen.ratgeberText,
                     }}
                  />
               )}
            </div>

            <div className=" flex-col">
               {props.data.antworten.map((antwort, index) => {
                  let buttonStyle = {};
                  if (antwort.weiter === "termin") {
                     buttonStyle.backgroundColor = "#00a";
                  }
                  if (antwort.text === "Termin vereinbaren") {
                     buttonStyle.backgroundColor = "#00a";
                  }
                  if (antwort.weiter === "absage") {
                     buttonStyle.backgroundColor = "#444";
                  }
                  if (antwort.text === "Vermerken") {
                     buttonStyle.backgroundColor = "#444";
                  }
                  if (antwort.weiter === "unterlagen") {
                     buttonStyle.backgroundColor = "#80a";
                  }
                  if (antwort.text === "Entsprechende Unterlagen versenden und auf Vorlage setzen") {
                     buttonStyle.backgroundColor = "#80a";
                  }

                  return (
                     <>
                        <button
                           style={buttonStyle}
                           disabled={!antwort.weiter}
                           className="leitfaden-button"
                           onClick={() => {
                              props.data.setPrevNode(props.data.currentNode);
                              props.data.setCurrentNode(antwort.weiter);
                              if (antwort.weiter === "unterlagen") {
                                 props.data.setUnterlagen(antwort);
                              }
                              handleTransform(anrufleitfadenObject[antwort.weiter].position);
                           }}
                        >
                           {/* {antwort.weiter} */}
                           {antwort.text}
                        </button>
                        {antwort.weiter && (
                           <Handle
                              type="source"
                              position={Position.Right}
                              id={"handle_" + props.id + "_" + index}
                              style={{
                                 right: 0,
                                 top: 55 + index * 65 + (ele && ele.current ? ele.current.offsetHeight : 0),
                              }}
                           />
                        )}
                     </>
                  );
               })}
               {/* <button
                  className="leitfaden-button mt-5"
                  style={{ backgroundColor: "#fff", color: "#000", boxShadow: "0 0 10px #999" }}
                  onClick={() => fitView({ duration: 1500 })}
               >
                  Zur Übersicht
               </button> */}
            </div>
         </div>
      </div>
   );
}

const handleStyle = { left: 10 };

function TextUpdaterNode(props) {
   return (
      <div className="text-updater-node">
         <div>Custom Node</div>
         <Handle type="target" position={Position.Top} />
         <Handle type="source" position={Position.Bottom} id="a" style={handleStyle} />
         <Handle type="source" position={Position.Bottom} id="b" />
      </div>
   );
}
